if(typeof Drupal !== 'undefined') {
  Drupal.behaviors.werkstueckspOverview = {
    attach(context) {
      if(document.querySelector('section#rueckbearbeitung.lp-werkstuecksp')) {
        initWerkstueckspOverview(document.querySelector('section#rueckbearbeitung.lp-werkstuecksp'));
      }
    }
  }
} else {
  if(document.querySelector('section#rueckbearbeitung.lp-werkstuecksp')) {
    initWerkstueckspOverview(document.querySelector('section#rueckbearbeitung.lp-werkstuecksp'));
  }
}

function initWerkstueckspOverview(context) {
  if(context.querySelectorAll('#wspvideoholder').length > 0 && !document.querySelector('#wspvideoholder').classList.contains('initiated')) {
    context.querySelector('#wspvideoholder').classList.add('initiated');

    let lock;
    let time;
    let video = document.getElementById("wspvideoholder");
    let zIndexCounter = 2;

    video.load();
    video.pause();

    function removeTimeupdateListeners() {
      video.removeEventListener('timeupdate', avantiInPlayed);
      video.removeEventListener('timeupdate', avantiOutPlayed);
      video.removeEventListener('timeupdate', profiloInPlayed);
      video.removeEventListener('timeupdate', profiloOutPlayed);
      video.removeEventListener('timeupdate', variotecInPlayed);
      video.removeEventListener('timeupdate', variotecOutPlayed);
      video.removeEventListener('timeupdate', magnetischInPlayed);
      video.removeEventListener('timeupdate', magnetischOutPlayed);
    }

    function toggleTooltip(id) {
      const tooltip = document.querySelector('.modal--tooltip#' + id);
      tooltip.classList.toggle('active');

      if(tooltip.classList.contains('active')) {
        zIndexCounter++;
        tooltip.style.zIndex = zIndexCounter;
      }
    }

    function closeTooltips() {
      context.querySelectorAll('.modal--tooltip').forEach((tooltip) => {
        tooltip.classList.remove('active');
        tooltip.style.zIndex = '';
      });
      zIndexCounter = 2;
    }

    function playCurrentOutMovement() {
      let animationTriggered = false;

      if(video.currentTime >= 1 && video.currentTime <= 2) { // avanti out
        video.currentTime = 2;
        video.addEventListener('timeupdate', avantiOutPlayed);
        closeTooltips();
        video.play();
        animationTriggered = true;
      }
      if(video.currentTime >= 5 && video.currentTime <= 6) { // profilo out
        video.currentTime = 6;
        video.addEventListener('timeupdate', profiloOutPlayed);
        closeTooltips();
        video.play();
        animationTriggered = true;
      }
      if(video.currentTime >= 9 && video.currentTime <= 10) { // variotec out
        video.currentTime = 10;
        video.addEventListener('timeupdate', variotecOutPlayed);
        closeTooltips();
        video.play();
        animationTriggered = true;
      }
      if(video.currentTime >= 13 && video.currentTime <= 14) { // magnetisch out
        video.currentTime = 14;
        video.addEventListener('timeupdate', magnetischOutPlayed);
        closeTooltips();
        video.play();
        animationTriggered = true;
      }

      // If video position doesn't match any range (e.g., video has ended), release the lock
      // if(!animationTriggered) {
      //   lock = false;
      // }
    }

    /* avanti */
    context.querySelector('.figure--button[data-target="avanti"]').addEventListener('click', (event) => {
      if(lock) { return; } else lock = true;
      if(time) clearTimeout(time);
      if(context.querySelector('.figure--button.active')) {
        context.querySelector('.figure--button.active').classList.remove('active');
      }
      const avantiTooltip = document.querySelector('.modal--tooltip#avanti');
      if(avantiTooltip && avantiTooltip.classList.contains('active')) {
        playCurrentOutMovement();
      } else {
        event.target.closest('figure').classList.add('active');

        playCurrentOutMovement();

        time = setTimeout(() => {
          video.currentTime = 0;
          video.addEventListener('timeupdate', avantiInPlayed);
          toggleTooltip('avanti');
          video.play();
        }, 1500);
      }
    });

    function avantiInPlayed() {
      if(video.currentTime >= 1) {
        removeTimeupdateListeners();
        video.pause();
        lock = false;
      }
    }

    function avantiOutPlayed() {
      if(video.currentTime >= 3.1) {
        video.pause();
        removeTimeupdateListeners();
        lock = false;
      }
    }

    /* profilo */
    context.querySelector('.figure--button[data-target="profilo"]').addEventListener('click', (event) => {
      if(lock) { return; } else lock = true;
      if(time) clearTimeout(time);
      if(context.querySelector('.figure--button.active')) {
        context.querySelector('.figure--button.active').classList.remove('active');
      }
      const profiloTooltip = document.querySelector('.modal--tooltip#profilo');
      if(profiloTooltip && profiloTooltip.classList.contains('active')) {
        playCurrentOutMovement();
      } else {
        event.target.closest('figure').classList.add('active');

        playCurrentOutMovement();

        time = setTimeout(() => {
          video.currentTime = 4;
          video.addEventListener('timeupdate', profiloInPlayed);
          toggleTooltip('profilo');
          video.play();
        }, 1500);
      }
    });

    function profiloInPlayed() {
      if(video.currentTime >= 5) {
        removeTimeupdateListeners();
        video.pause();
        lock = false;
      }
    }

    function profiloOutPlayed() {
      if(video.currentTime >= 7.1) {
        video.pause();
        removeTimeupdateListeners();
        lock = false;
      }
    }

    /* variotec */
    context.querySelector('.figure--button[data-target="vario-tec"]').addEventListener('click', (event) => {
      if(lock) { return; } else lock = true;
      if(time) clearTimeout(time);
      if(context.querySelector('.figure--button.active')) {
        context.querySelector('.figure--button.active').classList.remove('active');
      }
      const variotecTooltip = document.querySelector('.modal--tooltip#variotec');
      if(variotecTooltip && variotecTooltip.classList.contains('active')) {
        playCurrentOutMovement();
      } else {
        event.target.closest('figure').classList.add('active');

        playCurrentOutMovement();

        time = setTimeout(() => {
          video.currentTime = 8;
          video.addEventListener('timeupdate', variotecInPlayed);
          toggleTooltip('variotec');
          video.play();
        }, 1500);
      }
    });

    function variotecInPlayed() {
      if(video.currentTime >= 9) {
        removeTimeupdateListeners();
        video.pause();
        lock = false;
      }
    }

    function variotecOutPlayed() {
      if(video.currentTime >= 11.1) {
        video.pause();
        removeTimeupdateListeners();
        lock = false;
      }
    }

    /* magnetisch */
    context.querySelector('.figure--button[data-target="magnetisch"]').addEventListener('click', (event) => {
      if(lock) { return; } else lock = true;
      if(time) clearTimeout(time);
      if(context.querySelector('.figure--button.active')) {
        context.querySelector('.figure--button.active').classList.remove('active');
      }
      const magnetischTooltip = document.querySelector('.modal--tooltip#magnetisch');
      if(magnetischTooltip && magnetischTooltip.classList.contains('active')) {
        playCurrentOutMovement();
      } else {
        event.target.closest('figure').classList.add('active');

        playCurrentOutMovement();

        time = setTimeout(() => {
          video.currentTime = 12;
          video.addEventListener('timeupdate', magnetischInPlayed);
          toggleTooltip('magnetisch');
          video.play();
        }, 1500);
      }
    });

    function magnetischInPlayed() {
      if(video.currentTime >= 13) {
        removeTimeupdateListeners();
        video.pause();
        lock = false;
      }
    }

    function magnetischOutPlayed() {
      if(video.currentTime >= 15.1) {
        video.pause();
        removeTimeupdateListeners();
        lock = false;
      }
    }
  }
}
